import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ResponseBaseI } from '../../models/responseBase.interface';
import { ObtenerPreguntasRespuestasI } from '../../models/obtenerPreguntasRespuestas';
import { EnviarEncuestaI } from '../../models/responderEncuesta';
import { Solicitud } from '../../interfaces/referente/SolicitudDTO';

@Injectable({
  providedIn: 'root'
})
export class SurveyService {

  URI = environment.urlAPI;

  constructor(private http: HttpClient) { }

  getObtenerPreguntas() {
    return this.http.get<ResponseBaseI<ObtenerPreguntasRespuestasI>>(`${this.URI}/Encuesta/obtenerPreguntas`);
  }

  getObtenerRespuestas() {
    return this.http.get<ResponseBaseI<ObtenerPreguntasRespuestasI>>(`${this.URI}/Encuesta/obtenerRespuestas`);
  }

  postEncuesta(request: EnviarEncuestaI) {
    return this.http.post<ResponseBaseI>(`${this.URI}/Encuesta`, request)
  }
}
